import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useSocketEvent } from '../../../shared/socket.js';

export function useQuickProducts({ dept, q }) {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ['pos', 'products', dept, q || ''],
    enabled: !!dept,
    queryFn: async () => {
      const { data } = await api.get('/pos/products/quick', {
        params: { warehouseType: dept, q: q || undefined, limit: 30 }
      });
      return data?.items || data?.data || [];
    },
    staleTime: 5000,
    placeholderData: (prev) => prev
  });

  const invalidate = () => qc.invalidateQueries({ queryKey: ['pos', 'products'] });
  useSocketEvent('inventory', 'lowstock', invalidate);
  useSocketEvent('inventory', 'inventory:lowstock', invalidate);

  return query;
}

export function useCategoriesByWarehouse(warehouseId) {
  return useQuery({
    queryKey: ['catalog', 'categories', warehouseId],
    enabled: !!warehouseId,
    queryFn: async () => {
      const { data } = await api.get('/catalog/categories', {
        params: { warehouseId, active: true }
      });
      return data?.items || data?.data || [];
    },
    staleTime: 5 * 60 * 1000
  });
}
